import { IResourceModel, IPlay } from "../abstraction";

export class SoundService implements IPlay {
    constructor() {
        console.log("Sound service ready to groove");
    }

    private _soundBank: IResourceModel[] = [];

    public get soundBank() {
        return this._soundBank;
    }

    public set soundBank(bank: IResourceModel[]) {
        this._soundBank = bank;
    }

    private str2ab(str): ArrayBuffer {
        var buf = new ArrayBuffer(str.length); // 2 bytes for each char
        var bufView = new Uint8Array(buf);
        for (var i = 0, strLen = str.length; i < strLen; i++) {
            bufView[i] = str.charCodeAt(i);
        }
        return buf;
    }

    // Lance la lecture d'un son en arri�re plan
    public play(soundName: string):void {
        try {

            console.log(`Playing sound : .${soundName}.`);

            let target = this.soundBank.filter(x => x.code == soundName.trim())[0];

            if (target == undefined) {
                console.error(`Sound unavailable : ${soundName}`)
                return;
            }
            // Donn�es brutes format base64
            let base64AudioData = target.data;

            let rawAudioData = atob(base64AudioData);

            //// Context audio
            var audioCtx = new AudioContext();

            // Chargemenbt du son dans le buffer d�di�
            var audioBuffer = this.str2ab(rawAudioData)

            if (audioBuffer) {
                // D�codage du son (selon format) et lancement
                audioCtx.decodeAudioData(audioBuffer)
                    .then((sound) => {
                        var source = audioCtx.createBufferSource();
                        source.buffer = sound;
                        source.connect(audioCtx.destination);
                        source.start();
                    })
                    .catch((reason) => {
                        console.error(reason);
                        alert(reason)
                    });
            }
        }
        catch (err) {
            console.error(err);
            alert(err)
        }
    }

    public playOk = () => this.play(this.DefautSound_Ok);
    public playError = () => this.play(this.DefautSound_Error);
    public playWarning = () => this.play(this.DefautSound_Warning);

    public DefautSound_Ok: string = "";
    public DefautSound_Error: string = "";
    public DefautSound_Warning: string = "";
}